import axios from "axios";
const state = {};
import config from "@/../config";
const defaultErrorHandler = error => Promise.reject(error.response);

const mutations = {};

const actions = {
    async GET_FORM_DYNAMIC({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[1] + '/demanda/' + payload);
        return response.data;
    },

    async GET_PARAMS_DEMANDAS({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[0] + '/parametros/demandas/');
        return response.data;
    },

    async GET_PARAMS_PIPEFY({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[0] + '/parametros/pipefy');
        return response.data.conteudo;
    },
};

export default { state, mutations, actions };



// WEBPACK FOOTER //
// ./src/store/modules/utils.js